'use client';

import { createContext, useContext, type ReactNode } from 'react';
import { getSiteConfig, type Locale, type SiteConfig } from '@/lib/locale';

const defaultConfig = getSiteConfig('sv');

const LocaleContext = createContext<SiteConfig>(defaultConfig);

export function LocaleProvider({
  locale,
  children,
}: {
  locale: Locale; // 'sv' eller 'en' — sätts av sökvägens prefix, inte av domänen
  children: ReactNode;
}) {
  const config = getSiteConfig(locale);
  return (
    <LocaleContext.Provider value={config}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocaleContext(): SiteConfig {
  return useContext(LocaleContext);
}
